import { SpaqFireDb } from '@shared/core';
import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { SubscriptionInfo } from '@shared/core';
import { EMPTY, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable()
export class SubscriptionService {
	constructor(
		private afAuth: AngularFireAuth,
		private db: SpaqFireDb
	) {}

	hydrate(): Observable<SubscriptionInfo> {
		return this.afAuth.user.pipe(switchMap(u => (u ? this.db.userSubscription$<SubscriptionInfo>(u.uid) : EMPTY)));
	}
}
